<template>
    <div style="width: 100%;height: 100%;padding: 10px;" v-html="content"></div>
</template>

<script>
import { listAgreement } from "@/api/agreement/agreement";
import store from '@/store'
export default {
  name: "agreement",
  data() {
    return {
      content: '',
      queryParams: {
        category: '', //类别（1.用户协议 2.隐私协议）
        port: '', //发布端口（1.web 2.android 3.ios 4.小程序）
        application: 1 //应用名称（1.临床训练营 2.执业医师考试 3.规培中心）
      }
    };
  },
  watch: {
  },

  computed: {
  },

  // 页面加载钩子
  async created() {
    store.dispatch('settings/setTitle', '圣云医教云平台')
    if (this.$route.query.category) {
      this.queryParams.category = this.$route.query.category
    }
    if (this.$route.query.port) {
      this.queryParams.port = this.$route.query.port
    }
    if (this.$route.query.application) {
      this.queryParams.application = this.$route.query.application
    }
    await this.getAgreement();
  },

  methods: {
    // 查询公告列表信息
    getAgreement() {
      console.log(this.queryParams);
      listAgreement(this.queryParams).then(response => {
        this.content = response.data.content;
      });
    },
  }
};
</script>

